import React, {Suspense} from "react";
import rezStyle from "../styles/Rezensionen.module.scss";
import {useTranslation, Trans} from "react-i18next";

function HeaderComponent()
{
    const {t} = useTranslation('translation');
    return <div className="rezensionen">
	<main className="full_width">
	  <div className={rezStyle.zitat} id="bumiller">
		  <h2>{t('reviews.bumiller.h2')}</h2>
		  <h3><Trans i18nKey="reviews.bumiller.h3" components={{MyLink: (<a href="https://finken-bumiller.de" target="_blank" rel="noopener noreferrer">link</a>)}}/></h3>
		  <Trans i18nKey="reviews.bumiller.p" components={{ p: <p />, MyLink1: (<a href="https://www.mein-gotteslob.de" target="_blank" rel="noopener noreferrer">link</a>), MyLink2: (<a href="https://finken-bumiller.de" target="_blank" rel="noopener noreferrer">link</a>)}}/>
		  <p className={rezStyle.verweis}><Trans i18nKey="reviews.bumiller.ex" components={{MyLink: (<a href="examples.html#gotteslob" target="_blank" rel="noopener noreferrer">link</a>)}}/></p>
	  </div>
	  <div className={rezStyle.zitat}>
		  <h2>{t('reviews.trauer.h2')}</h2>
		  <h3>{t('reviews.trauer.h3')}</h3>
		  <Trans i18nKey="reviews.trauer.p" components={{p: <p />,MyLink: (<a href="www.ekkw.de/emv" target="_blank" rel="noopener noreferrer">link</a>)}}/>
	  </div>
	  <div className={rezStyle.zitat} id="wiener">
		  <h2>{t('reviews.wue.h2')}</h2>
		  <h3>{t('reviews.wue.h3')}</h3>
		  <Trans i18nKey="reviews.wue.p" components={{p: <p />, MyLink: (<a href="www.wiener-urtext.com" target="_blank" rel="noopener noreferrer">link</a>)}}/>
		  <p className={rezStyle.verweis}><Trans i18nKey="reviews.wue.ex" components={{MyLink: (<a href="examples.html#wiener" target="_blank" rel="noopener noreferrer">link</a>)}}/></p>
	  </div>
	  <div className={rezStyle.zitat}>
		  <h2>{t('reviews.fidula.h2')}</h2>
		  <h3>{t('reviews.fidula.h3')}</h3>
		  <Trans i18nKey="reviews.fidula.p" components={{MyLink: (<a href="www.fidula.de" target="_blank" rel="noreferrer">link</a>)}}/>
	  </div>
  </main>
  </div>
}

function Rezensionen() {
  return (
    <Suspense fallback="loading">
            <div className="App">
                <HeaderComponent/>
            </div>
        </Suspense>
  );
}

export default Rezensionen;
